import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";

import {
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getOrgDataById,
  getRefFromId,
  queryCollection,
} from "../../models/DataFunctions.js";

import Space from "../../layout/Space.js";

import PrimaryButton from "../../buttons/PrimaryButton.js";

import modifyFolder from "../../api/modify/modifyFolder.js";
import dayjs from "dayjs";
import { useSnackbar } from "notistack";
import { useAppContext } from "../../config/AppContext.js";
import SmallSpinner from "../../loading/SmallSpinner.js";
import { set, setDate } from "date-fns";
import DropDownGPT1 from "../../dropdowns/DropDownGPT1.js";
import TextField2 from "../../textfields/TextField2.js";
import Icon1 from "../../icons/Icon.js";
import { addActivityLog } from "../../config/OnlineStatus.js";
import DropDownGPT0X from "../../dropdowns/DropDownGTP0X.js";
import DropDownGPT1X from "../../dropdowns/DropDownGPT1X.js";
import TextField2T from "../../textfields/TextField2T.js";
import DatePickerGPT0 from "../../textfields/DatePickerGPT0.js";
import DropDownGPT03 from "../../dropdowns/DropDownGTP03.js";
import DropDownGPTS3 from "../../dropdowns/DropDownGPTS3.js";
import { ToggleSettingsBrick } from "../../textfields/EasySwitch.js";

import { getCommunWorkspace } from "./FolderHelpers.js";
import SecondaryButton from "../../buttons/SecondaryButton.js";
import { getOrgById } from "../../models/OrgFunctions.js";
import updateDocApi from "../../api/database/updateDocApi.js";
import { hi } from "date-fns/locale";
import { fetchPostalCodesApi } from "../../api/google_places/GooglePlacesApi.js";

function ModifyPayment({ userData, orgData, navigateWorkspace, masterData }) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const { currentUser, loading } = useAuth();

  const [clients, setClients] = useState([]);
  const [clients_name_options, setClients_options] = useState([]);
  const [paymentData, setPaymentData] = useState(null);
  const [reglement_infos, setReglement_infos] = useState({});
  const { appState, setAppState } = useAppContext();
  const [resend_email, setResend_email] = useState(true);
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  // State variables to store the input values

  // Fetch payment and client data when the component mounts
  const handleFetchData = async () => {
    if (userData) {
      try {
        // Fetch user and organization data

        // Fetch payment data based on the payment id
        const payment = await getDocDataById("payment", id);

        // it is a DD/MM/YYYY string
        // Please convert to days date

        // date is a string in the format "DD/MM/YYYY"

        // Update state with fetched data
        setPaymentData(payment);
        setReglement_infos(payment.reglement_infos || {});
        setCitiesName([payment.reglement_infos?.city || ""]);
        setPostalCodes([payment.reglement_infos?.postal || ""]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const [citiesName, setCitiesName] = useState([]);
  const [postalCodes, setPostalCodes] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const fetchPostalCodes = async (city, exact_match = false) => {
    await fetchPostalCodesApi(
      setCitiesName,
      setPostalCodes,
      setPostal,
      setLoadingSearch,
      prefix,
      city,
      exact_match,
      postal
    );
  };

  const handleModifyPayment = async () => {
    setLoadingData(true);
    let history_events = paymentData.history_events || [];
    history_events.push({
      date: getFlutterTime(),
      name: "Modification des informations",
    });
    await updateDocApi(
      getRefFromId("payment", paymentData.id),
      {
        ...paymentData,
        reglement_infos: reglement_infos,
        history_events: history_events,
      },
      prefix
    );

    handleClickVariant("Paiement modifié avec succès", "success");
    navigateWorkspace("/payment/" + paymentData.id);
    setLoadingData(false);
  };

  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  // Fill the form with paymentData once it's fetched

  const [loadingData, setLoadingData] = useState(false);

  if (loading || !paymentData) {
    return <div></div>; // Show loading state while fetching data
  }

  return (
    <div className=" flex flex-col h-full w-full  overflow-auto  ">
      <div className="flex flex-col  h-fit  w-full pl-4 pb-40 max-w-c400">
        <div
          className="w-full cursor-pointer flex gap-2 flex-row h-fit items-center"
          onClick={() => navigateWorkspace(-1)}
        >
          <div className="text-h2 font-semibold text-primary_l bg-transparent">
            Page dossier
          </div>
          <Icon1 icon_name="right" size={14}></Icon1>
        </div>
        <div className="text-h1 font-semibold mt-2">Modifier le dossier</div>{" "}
        <div className="h-fit flex flex-col w-full mt-4 pr-2 gap-2" y={10}>
          <div className="flex flex-col gap-2 border-l-2 border-cyan-300 pl-2">
            <TextField2T
              className="w-full"
              label="Prénom du maître d'ouvrage"
              value={reglement_infos.first_name || ""}
              mandatory={true}
              onChange={(e) =>
                setReglement_infos({
                  ...reglement_infos,
                  first_name: e.target.value,
                })
              }
              transparent={false}
            ></TextField2T>
            <TextField2T
              className="w-full"
              label="Nom du maître d'ouvrage"
              value={paymentData.nom || ""}
              mandatory={true}
              onChange={(e) =>
                setPaymentData({ ...paymentData, nom: e.target.value })
              }
              transparent={false}
            ></TextField2T>
          </div>
          <div className="flex flex-col gap-2 border-l-2 border-blue-300 pl-2 mt-6">
            <DropDownGPTS3
              label="Ville"
              value={reglement_infos.city || ""}
              mandatory={true}
              onChange={(e) => {
                setReglement_infos({
                  ...reglement_infos,
                  city: e.value,
                });
                fetchPostalCodes(e.value, true);
              }}
              active_filter_inculdes={false}
              onSearchChange={(value) => {
                console.log("searching for city", value);
                fetchPostalCodes(value);
              }}
              debounceDelay={500}
              loadingSearch={loadingSearch}
              transparent={false}
              items={citiesName.map((city) => ({
                value: city,
                label: city,
              }))}
            ></DropDownGPTS3>
            <DropDownGPTS3
              label="Code Postal"
              value={reglement_infos.postal || ""}
              disabled={citiesName.length === 0}
              loadingSearch={loadingSearch}
              mandatory={true}
              onChange={(e) =>
                setReglement_infos({
                  ...reglement_infos,
                  city: e.value,
                })
              }
              transparent={false}
              items={postalCodes.map((code) => ({
                value: code,
                label: code,
              }))}
            ></DropDownGPTS3>{" "}
            <TextField2T
              label="Adresse"
              value={reglement_infos.address || ""}
              onChange={(e) =>
                setReglement_infos({
                  ...reglement_infos,
                  address: e.target.value,
                })
              }
              mandatory={false}
            />
          </div>
          <div className="flex flex-col gap-2 border-l-2 border-violet-300 pl-2 mt-6 mb-6">
            <div className="h-full flex flex-col gap-2">
              <TextField2T
                type="euros"
                value={paymentData.amount}
                disabled={paymentData?.state === "paid"}
                onChange={(e) => {
                  setPaymentData({
                    ...paymentData,
                    amount: e.target.value,
                  });
                }}
                className="w-c150"
                label="Montant"
              />
              <TextField2T
                className="w-full"
                label="Email du particulier"
                value={reglement_infos.email || ""}
                onChange={(e) =>
                  setReglement_infos({
                    ...reglement_infos,
                    email: e.target.value,
                  })
                }
                transparent={false}
                mandatory={true}
              ></TextField2T>
              <TextField2T
                className="w-full"
                label="Téléphone du particulier"
                value={reglement_infos.phone || ""}
                type="phone"
                onChange={(e) =>
                  setReglement_infos({
                    ...reglement_infos,
                    phone: e.target.value,
                  })
                }
                mandatory={true}
                transparent={false}
              ></TextField2T>
            </div>
          </div>
          {/* 
          <ToggleSettingsBrick
            title="Renvoyer un email au particulier"
            description={
              "Un email sera envoyé au particulier avec les nouvelles informations et un lien pour effectuer le paiement en ligne."
            }
            checked={resend_email}
            onChange={setResend_email}
          ></ToggleSettingsBrick> */}
        </div>
        <div className="w-full h-fit flex flex-row justify-end gap-2 mt-6 ">
          <SecondaryButton
            onClick={() => {
              navigateWorkspace("/payment/" + id);
            }}
          >
            Annuler
          </SecondaryButton>
          <PrimaryButton onClick={handleModifyPayment} disabled={loadingData}>
            <div className="flex flex-row content-center align-middle items-center">
              Enregistrer les modifications <Space x={5} />
              <SmallSpinner loading={loadingData} margin={0} size={20} />
            </div>
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default ModifyPayment;
